import styled from "styled-components";

export const Div = styled.div`
  &.color-blue {
    color: rgb(44, 118, 170);
  }
  .container {
  }
  .availble-item {
    display: flex;
  }
  .description {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .icon {
    width: 14px;
    height: 14px;
    padding-top: 2px;
    margin-right: 10px;
  }
  .srv-web-btn {
    height: fit-content;
    width: 100%;
    padding: 10px 7px;
    display: flex;
  }
  .srv-web-btn p {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 22px;
    padding-left: 10px;
    margin: auto 0;
    margin-bottom: -5px;
    text-decoration: underline;
    flex: 1;
  }
  .srv-web-btn svg {
    margin-top: 4px;
  }
`;
export const TextLabel = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 22px;
`;
